module.exports = __webpack_public_path__ + "static/media/datacake.940a65b6.svg";